import { createRouter, createWebHistory } from "vue-router";
import AnasayfaView from "../views/AnasayfaView.vue";
import LoginView from "../views/LoginView.vue";
import MusteriLoginView from "../views/MusteriLoginView.vue";
import MusteriPanelView from "../views/MusteriPanelView.vue";

import ProfilView from "../views/ProfilView.vue";


  import KullanicilarView from "../views/KullanicilarView.vue";
	import KullanicilarDetayView from "../views/KullanicilarDetayView.vue";

    import RollerView from "../views/RollerView.vue";

    import MusterilerView from "../views/MusterilerView.vue";
	import MusterilerDetayView from "../views/MusterilerDetayView.vue";

    import IslerView from "../views/IslerView.vue";
	import IslerDetayView from "../views/IslerDetayView.vue";

    import MusterinotlarView from "../views/MusterinotlarView.vue";
import RaporlarView from "../views/RaporlarView.vue";
import SistemAyarlarView from "../views/SistemAyarlarView.vue";

    import IsturlerView from "../views/IsturlerView.vue";

  import YapilacaklarView from "../views/YapilacaklarView.vue";
	import YapilacaklarDetayView from "../views/YapilacaklarDetayView.vue";



    import BildirimlerView from "../views/BildirimlerView.vue";

  import FikirlerView from "../views/FikirlerView.vue";
import {
    isAgencyAuthenticated,
    isMusteriAuthenticated,
    clearInvalidTokens,
} from '@/services/auth';

    import ElimdekiIslerView from '../views/ElimdekiIslerView.vue';

    const routes = [
        {
            path: "/login",
            name: "Login",
            component: LoginView,
        },
        
        {
            path: "/musterilogin",
            name: "musterilogin",
            component: MusteriLoginView,
        },
        {
          path: "/musteripanel",
          name: "musteripanel",
          component: MusteriPanelView,
      },

        {
            path: "/",
            redirect: () => (isAgencyAuthenticated() ? '/anasayfa' : '/login'),
        },
        {
            path: "/anasayfa",
            name: "anasayfa",
            component: AnasayfaView,
        },
        {
            path: "/profil",
            name: "profil",
            component: ProfilView,
        },
        {
            path: "/kullanicilar",
            name: "kullanicilar",
            component: KullanicilarView,
        },
        {
            path: '/kullanicilar/:id/:tab?',
            name: 'kullanicilardetay',
            component: KullanicilarDetayView,
            beforeEnter: (to, from, next) => {
              // tab parametresini kontrol et
              if (!to.params.tab) {
                // tab parametresi belirtilmemişse, varsayılan değeri ata
                to.params.tab = 'bilgiler';
              }
              // Yönlendirmeyi devam ettir
              next();
            }
          },
        {
            path: "/roller",
            name: "roller",
            component: RollerView,
        },
   
        {
            path: "/musteriler",
            name: "musteriler",
            component: MusterilerView,
        },
        {
            path: '/musteriler/:id/:tab?',
            name: 'musterilerdetay',
            component: MusterilerDetayView,
            beforeEnter: (to, from, next) => {
              // tab parametresini kontrol et
              if (!to.params.tab) {
                // tab parametresi belirtilmemişse, varsayılan değeri ata
                to.params.tab = 'bilgiler';
              }
              // Yönlendirmeyi devam ettir
              next();
            }
          },
        {
            path: "/isler",
            name: "isler",
            component: IslerView,
        },
        {
            path: '/isler/:id/',
            name: 'islerdetay',
            component: IslerDetayView,
          },
        {
            path: "/musterinotlar",
            name: "musterinotlar",
            component: MusterinotlarView,
        },
        {
            path: "/raporlar",
            name: "raporlar",
            component: RaporlarView,
        },
        {
            path: "/sistemayarlar",
            name: "sistemayarlar",
            component: SistemAyarlarView,
        },
       
        {
            path: "/isturler",
            name: "isturler",
            component: IsturlerView,
        },
        
        {
            path: "/yapilacaklar",
            name: "yapilacaklar",
            component: YapilacaklarView,
        },
        {
            path: '/yapilacaklar/:id/:tab?',
            name: 'yapilacaklardetay',
            component: YapilacaklarDetayView,
            beforeEnter: (to, from, next) => {
              // tab parametresini kontrol et
              if (!to.params.tab) {
                // tab parametresi belirtilmemişse, varsayılan değeri ata
                to.params.tab = 'bilgiler';
              }
              // Yönlendirmeyi devam ettir
              next();
            }
          },
       
       
        {
            path: "/bildirimler",
            name: "bildirimler",
            component: BildirimlerView,
        },
     
        {
            path: "/fikirler",
            name: "fikirler",
            component: FikirlerView,
        },
      
        {
            path: '/elindekiisler',
            name: 'ElimdekiIsler',
            component: ElimdekiIslerView,
            meta: { requiresAuth: true }
        },
    ];


const router = createRouter({
    history: createWebHistory(),
    routes,
});


router.beforeEach((to, from, next) => {
    clearInvalidTokens();

    const agencyAuth = isAgencyAuthenticated();
    const musteriAuth = isMusteriAuthenticated();

    const isAgencyLogin = to.name === 'Login';
    const isMusteriLogin = to.name === 'musterilogin';
    const isMusteriPanel = to.name === 'musteripanel';

    if (musteriAuth && !agencyAuth) {
        if (isMusteriLogin) {
            return next({ name: 'musteripanel' });
        }
        if (!isMusteriPanel && !isMusteriLogin) {
            return next({ name: 'musteripanel' });
        }
        return next();
    }

    if (agencyAuth) {
        if (isAgencyLogin || isMusteriLogin) {
            return next({ name: 'anasayfa' });
        }
        if (isMusteriPanel) {
            return next({ name: 'anasayfa' });
        }
        return next();
    }

    if (isAgencyLogin || isMusteriLogin) {
        return next();
    }

    if (isMusteriPanel) {
        return next({ name: 'musterilogin' });
    }

    return next({ name: 'Login' });
});

export default router;